import { useState } from "react";
import { apiPublic } from "../api/robyBackend";
import { Link } from "react-router-dom";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setMsg("");
    try {
      await apiPublic.post("/api-roby/password-reset/", { email });
      setMsg("Wenn die E-Mail registriert ist, wurde ein Reset-Link gesendet.");
    } catch {
      setMsg("Wenn die E-Mail registriert ist, wurde ein Reset-Link gesendet.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2>Passwort zurücksetzen</h2>

        <form onSubmit={submit}>
          <input
            type="email"
            placeholder="E-Mail-Adresse"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <button type="submit" disabled={!email || busy}>
            {busy ? "Sende…" : "Reset-Link senden"}
          </button>
        </form>

        {msg && <p className="info">{msg}</p>}

        <div className="forgot-password" style={{ marginTop: 16 }}>
          <Link to="/login">Zurück zum Login</Link>
        </div>
      </div>
    </div>
  );
}
